export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-5.9c68f02e.jpg";